export default function Home () {
    return (
        <div>
            <h1 id="home">Welcome Agent</h1>
            <img width='100%' height='auto'src='https://wallpapers.com/images/featured/305kescxw5dpup7y.jpg' alt='Main Background'></img>
        </div>
    )
}